import React from "react";

const AllNotifications = () => {
  return (
    <div>
      <h1>AllNotifications</h1>
    </div>
  );
};

export default AllNotifications;
